module.exports = __webpack_public_path__ + "img/01.dd27fbf9.png";